import { render, staticRenderFns } from "./recommendIndex.vue?vue&type=template&id=777a9400&scoped=true"
import script from "./recommendIndex.vue?vue&type=script&lang=js"
export * from "./recommendIndex.vue?vue&type=script&lang=js"
import style0 from "./recommendIndex.vue?vue&type=style&index=0&id=777a9400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777a9400",
  null
  
)

export default component.exports